import React from 'react';

/**
 * Standard heading for every dashboard widget.
 *
 *   <WidgetHeader icon={Users} title="Total Employees" />
 *
 * Renders a 16px lucide icon inside a small circular soft-grey pill
 * (macOS-widget style), accented with brand orange, to the left of
 * the heading text.
 */
const WidgetHeader = ({ icon: Icon, title, children, action }) => (
  <h3 className="widget-head">
    {Icon && (
      <span className="widget-head-iconpill">
        <Icon size={16} strokeWidth={1.75} />
      </span>
    )}
    <span className="widget-head-title">{title}</span>
    {children}
    {action && <span style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center' }}>{action}</span>}
  </h3>
);

export default WidgetHeader;
